import React, { useState, useEffect } from "react";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import parse from 'html-react-parser';

import Select from 'react-select';

import 'react-base-table/styles.css'

import { api_crud_base, api_crud_route, api_list_route, endpoints, data_interface } from './Config';

import { 
    reqGET, 
    reqPOST, 
    reqPUT, 
    reqDELETE, 
    functionSendMail 
} from '../../../Utils';
import Hosts from '../../../Hosts';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import Calendar from '@toast-ui/react-calendar';
import 'tui-calendar/dist/tui-calendar.css';

// If you use the default popups, use this.
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';

import jsPDF from 'jspdf'
import 'jspdf-autotable'

import { language } from './Language';
//import { set } from "core-js/core/dict";

export default function List(props) {

    const [, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

	const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [, set_permissions] = useState({})

    const [modal_name, set_modal_name] = useState('');
    //const [modal_email, set_modal_email] = useState('');
    //const [modal_cojntacto, set_modal_cojntacto] = useState('');
    const [modal_category, set_modal_category] = useState('');
    const [modal_category_id, set_modal_category_id] = useState('0');
    const [modal_date, set_modal_date] = useState('');
    const [modal_horario, set_modal_horario] = useState([]);
    const [modal_instrutor_id, set_modal_instrutor_id] = useState('');
    const [modal_instrutor_name, set_modal_instrutor_name] = useState('');
    const [modal_horario_value_edit, set_modal_horario_value_edit] = useState('');
    const [modal_horario_label_edit, set_modal_horario_label_edit] = useState('');

    const [modal_event_id, set_modal_event_id] = useState('');

    const [modal_event_dados, set_modal_event_dados] = useState('');

    const [schedueles, setSchedueles] = useState([]);
    const [calendars, setCalendars] = useState([]);
    const [selectedView, setSelectedView] = useState('day');
    const [calendarTitle, setcalendarTitle] = useState('');

    const [map_date, set_map_date] = useState('');

    const [instrutores, set_instrutores] = useState([]);

    const [, set_horarios_agendados] = useState([]);

	const [refresh, setRefresh] = useState(0);

    const [aulas_types, ] = useState([
		{ value: "Ski", label: "Ski" },
		{ value: "Snowboard", label: "Snowboard" }
	])

    const h = [
        {value:'0', label: '09:30 - 10:30', begin: '09:30', end: '10:30', state: true},
        {value:'1', label: '10:00 - 11:00', begin: '10:00', end: '11:00', state: true},
        {value:'2', label: '10:30 - 11:30', begin: '10:30', end: '11:30', state: true},
        {value:'3', label: '11:00 - 12:00', begin: '11:00', end: '12:00', state: true},
        {value:'4', label: '11:30 - 12:30', begin: '11:30', end: '12:30', state: true},
        {value:'5', label: '12:00 - 13:00', begin: '12:00', end: '13:00', state: true},
        {value:'6', label: '12:30 - 13:30', begin: '12:30', end: '13:30', state: true},
        {value:'7', label: '13:00 - 14:00', begin: '13:00', end: '14:00', state: true},
        {value:'8', label: '13:30 - 14:30', begin: '13:30', end: '14:30', state: true},
        {value:'9', label: '14:00 - 15:00', begin: '14:00', end: '15:00', state: true},
        {value:'10', label: '14:30 - 15:30', begin: '14:30', end: '15:30', state: true},
        {value:'11', label: '15:00 - 16:00', begin: '15:00', end: '16:00', state: true},
        {value:'12', label: '15:30 - 16:30', begin: '15:30', end: '16:30', state: true}
    ]

    const [horario, set_horario] = useState(h)
    /*
    const [horario_start, ] = useState([
        {value: '09:30', label: '09:30'},
        {value: '10:00', label: '10:00'},
        {value: '10:30', label: '10:30'},
        {value: '11:00', label: '11:00'},
        {value: '11:30', label: '11:30'},
        {value: '12:00', label: '12:00'},
        {value: '12:30', label: '12:30'},
        {value: '13:00', label: '13:00'},
        {value: '13:30', label: '13:30'},
        {value: '14:00', label: '14:00'},
        {value: '14:30', label: '14:30'},
        {value: '15:00', label: '15:00'},
        {value: '15:30', label: '15:30'}
    ])
    const [horario_end, ] = useState([
        {value: '10:30', label: '10:30'},
        {value: '11:00', label: '11:00'},
        {value: '11:30', label: '11:30'},
        {value: '12:00', label: '12:00'},
        {value: '12:30', label: '12:30'},
        {value: '13:00', label: '13:00'},
        {value: '13:30', label: '13:30'},
        {value: '14:00', label: '14:00'},
        {value: '14:30', label: '14:30'},
        {value: '15:00', label: '15:00'},
        {value: '15:30', label: '15:30'},
        {value: '16:00', label: '16:00'},
        {value: '16:30', label: '16:30'}
    ])
    */

    // var today = new Date()

    var calendar_views = [
        {
            name: language[lang].calendar_month,
            value: 'month'
        }, 
        {
            name: language[lang].calendar_week,
            value: 'week'
        },
        {
            name: language[lang].calendar_day,
            value: 'day'
        }
    ]

    /*
    const getDate = (type, start, value, operator) => {
        start = new Date(start);
        type = type.charAt(0).toUpperCase() + type.slice(1);
    
        if (operator === '+') {
            start[`set${type}`](start[`get${type}`]() + value);
        } 
        else {
            start[`set${type}`](start[`get${type}`]() - value);
        }
    
        return start;
    };

    const aux_schedueles = [
    //     {
    //         id: '1',
    //         calendarId: '1',
    //         title: 'TOAST UI Calendar Study',
    //         category: 'time',
    //         dueDateClass: '',
    //         start: today.toISOString(),
    //         end: getDate('hours', today, 3, '+').toISOString()
    //     },
    //     {
    //         id: '2',
    //         calendarId: '0',
    //         title: 'Practice',
    //         category: 'time',
    //         dueDateClass: '',
    //         start: getDate('date', today, 1, '+').toISOString(),
    //         end: getDate('date', today, 1, '+').toISOString(),
    //         isReadOnly: true
    //     },
    //     {
    //         id: '3',
    //         calendarId: '0',
    //         title: 'FE Workshop',
    //         category: 'allday',
    //         dueDateClass: '',
    //         start: getDate('date', today, 2, '-').toISOString(),
    //         end: getDate('date', today, 1, '-').toISOString(),
    //         isReadOnly: true
    //     },
    //     {
    //         id: '4',
    //         calendarId: '0',
    //         title: 'Report',
    //         category: 'milestone',
    //         dueDateClass: '',
    //         start: today.toISOString(),
    //         end: getDate('hours', today, 1, '+').toISOString()
    //     }
    ]
    */

    const [, set_aux_calendars] = useState([])
    const [base_color, ] = useState('4035019')
    // const aux_calendars = [
    //     {
    //         id: '0',
    //         name: 'Pessoal',
    //         bgColor: '#9e5fff',
    //         borderColor: '#9e5fff',
    //         status: true
    //     },
    //     {
    //         id: '1',
    //         name: 'Formação 1',
    //         bgColor: '#00a9ff',
    //         borderColor: '#00a9ff',
    //         status: true
    //     }
    // ]

    const get_events = async (start, end) => {
        //await reqGET(`${api_crud_base}/estancia/aula/event/${getTokenInfo().companycode}`)
        await reqGET(`${api_crud_base}/estancia/aula/event/range/${getTokenInfo().companycode}/${start}/${end}`)
            .then(res => { 
                // setData(res.data); setLoading(false) 
                // console.log(res.data)

                let aux_schedueles = []
                res.data.forEach((v) => {
                    aux_schedueles.push({
                        id: v.id,
                        companycode: v.info.companycode,
                        //calendarId: v.info.detail.calendarId,
                        //calendarId: v.info.instrutor.id,
                        calendarId: v.info.detail.state === 'busy' ? '0' : (v.info.detail.state === 'done' ? '2' : v.info.detail.state === 'cancel' ? '3' : '1'),
                        //title: v.info.name + (v.info.instrutor.name !== '' ? ' - ' + v.info.instrutor.name : ''),
                        //title: v.info.instrutor.name + (v.info.detail.state === 'busy' ? ' (Agendada)' : ''),
                        // title: (v.info.detail.state === 'busy' ? 'Agendada' : (v.info.detail.state === 'done' ? 'Realizada' : (v.info.detail.state === 'cancel' ? 'Cancelada' : 'Disponível'))) + ' (' + v.info.category + ' - ' + (v.info.instrutor.name !== '' ? v.info.instrutor.name : '') + (v.info.inscritos[0].name !== undefined && v.info.inscritos[0].name !== '' ? ' - ' + v.info.inscritos[0].name : '') + ')',
                        title: (v.info.detail.state === 'busy' ? 'Agendada' : (v.info.detail.state === 'done' ? 'Realizada' : (v.info.detail.state === 'cancel' ? 'Cancelada' : 'Disponível'))) 
                            + ' (' + v.info.category + ' - ' + (v.info.instrutor.name !== '' ? v.info.instrutor.name : '') 
                            + (v.info.inscritos[0].name !== undefined && v.info.inscritos[0].name !== '' ? ' - ' + v.info.inscritos[0].name : '') 
                            + (v.info.inscritos[0].name !== undefined && v.info.inscritos[0].name !== '' && v.info.inscritos[0].aux_qrcode !== undefined && v.info.inscritos[0].aux_qrcode.length > 0 ? (' - ' + v.info.inscritos[0].aux_qrcode.length + (v.info.inscritos[0].aux_qrcode.length === 1 ? ' aluno' : ' alunos')) : '') 
                        + ')',
                        category: v.info.detail.category,
                        dueDateClass: v.info.detail.dueDateClass,
                        start: v.info.detail.start,
                        end: v.info.detail.end,
                        isAllDay: v.info.detail.isAllDay,
                        location: v.info.detail.location.name,
                        state: v.info.detail.state,
                        raw: v.info.detail.raw.class,
                        isReadOnly: v.info.detail.isReadOnly,
                        instrutor: {
                            id: v.info.instrutor.id, 
                            name: v.info.instrutor.name
                        },
                        inscritos: v.info.inscritos,
                        tipo: v.info.category,
                        body: ''
                    })
                })

                // console.log(aux_schedueles)
                setSchedueles(aux_schedueles)
            })
            .catch(() => 404)
    }

    const get_info = async () => {
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                //console.log(res.data)
                setData(res.data);
                //setLoading(false)
            })
            .catch(() => 404
        )
    }


    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {



        var today_2 = new Date()

        const get_instrutores = async () => {
            //setLoading(true);
            return await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Instrutor`)
                .then(res => {
                    //set_instrutores(res.data);
    
                    let aux_color = parseInt(base_color)
                    let aux = []
                    let aux2 = []
                    res.data.forEach(el => {
                        aux.push({value: el.id, label: el.name})
                        aux2.push({id: el.id, name: el.name, bgColor: '#' + aux_color.toString(16).toUpperCase(), borderColor: '#' + aux_color.toString(16).toUpperCase(), color: '#ffffff', status: true})
    
                        aux_color = parseInt(aux_color) + 100
                    })
                    set_instrutores(aux)
                    set_aux_calendars(aux2)
                    //setCalendars(aux2)
    
                    //setLoading(false);
                })
                .catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
        }

        if(modal_date === '') {
            set_map_date(today_2.getFullYear() + '-' + ((today_2.getMonth() + 1) + '').padStart(2, '0') + '-' + (today_2.getDate() + '').padStart(2, '0'))
            set_modal_date(today_2.getFullYear() + '-' + ((today_2.getMonth() + 1) + '').padStart(2, '0') + '-' + (today_2.getDate() + '').padStart(2, '0'))

            set_modal_category('Ski')
            set_modal_category_id('1')
        }

        get_info()
        get_instrutores()

        let d1 = new Date(today_2.getFullYear(), today_2.getMonth(), 1)
        let d2 = new Date(today_2.getFullYear(), today_2.getMonth() + 1, 0)

        let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
        let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

        if(modal_date === '') {
            // Swal.fire('', 'useeffect', 'info')
            get_events(start, end)
        }

        setCalendars([
            {
                id: '0',
                name: 'Busy',
                bgColor: '#9e5fff',
                borderColor: '#9e5fff',
                color: '#ffffff',
                status: true
            },
            {
                id: '1',
                name: 'Free',
                bgColor: '#03bd9e',
                borderColor: '#03bd9e',
                color: '#ffffff',
                status: true
            },
            {
                id: '2',
                name: 'Done',
                bgColor: '#00a9ff',
                borderColor: '#00a9ff',
                color: '#ffffff',
                status: true
            },
            {
                id: '3',
                name: 'Cancel',
                bgColor: '#ff4040',
                borderColor: '#ff4040',
                color: '#ffffff',
                status: true
            }
        ])

        // setCalendars([
        //     {
        //         id: '1',
        //         name: 'Ski',
        //         bgColor: '#00a9ff',
        //         borderColor: '#00a9ff',
        //         status: true
        //     },
        //     {
        //         id: '2',
        //         name: 'Snowboard',
        //         bgColor: '#9e5fff',
        //         borderColor: '#9e5fff',
        //         status: true
        //     }
        // ])

        //setSchedueles(aux_schedueles)
        //setCalendars(aux_calendars)

        //setcalendarTitle(today_2.toLocaleString(language[localStorage.getItem('lang')].calendar_language, { month: 'long', year: 'numeric' }))
        setcalendarTitle(today_2.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))


        set_lang(localStorage.getItem('lang'))

        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                setLoading(false)
            });
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [pathname, lang, base_color, refresh/*, modal_date*/]);

    /*
    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(res => {
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
    }

    const columns = [
        {
            name: language[lang].field_name,
            selector: 'info.name',
            maxWidth: '40% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_category,
            selector: 'info.category',
            maxWidth: '20% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].start,
            selector: 'info.detail.start',
            cell: row => <span>
                {row.info.detail.start.split('T')[0]} - {row.info.detail.start.split('T')[1]}
            </span>,
            maxWidth: '20% !important',
            minWidth: '160px !important',
            sortable: true,
            left: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            maxWidth: '20% !important',
            minWidth: '142px !important',
            cell: row => 
                <span>
                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                    permissions.edit ?
                        <Link className="button button-update" to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} style={{ display: '' }} replace>
                            <i className="bi bi-pencil"></i>
                        </Link>
                    :
                        null
                    }

                    {
                    permissions.remove ?
                        <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                            <i className="bi bi-trash"></i>
                        </button>
                    :
                        null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const change_date = e => {
        console.log(e)
    }
    */

    const change_aulas_type = e => {
        set_modal_category(e.value)

        if (e.value.localeCompare('Ski') === 0) {
			set_modal_category_id('1')
		}
		else if (e.value.localeCompare('Snowboard') === 0) {
			set_modal_category_id('2')
		}


        horario.forEach((element) => {
            element.state = true
        })

        if(modal_date !== '') {
            reqGET(`${api_crud_base}/estancia/aula/event/instrutor/${getTokenInfo().companycode}/${modal_date}`)
                .then(res => { 

                    let aux_schedueles = []
                    res.data.forEach((v) => {
                        if(v.info.detail.start.includes(modal_date) && v.info.instrutor.id === modal_instrutor_id) {
                            aux_schedueles.push({
                                start: v.info.detail.start,
                                end: v.info.detail.end,
                            })

                            let x = horario
                            if(v.info.category === e.value) {
                                x.forEach((element) => {
                                    if(v.info.detail.start.includes(element.begin)) {
                                        element.state = false
                                    }
                                })
                            }
                            else {
                                x.forEach((element) => {
                                    if(v.info.detail.start.includes(element.begin) && v.info.detail.state !== 'free') {
                                        element.state = false
                                    }
                                })
                            }
                            set_horario(x)
                            // setRefresh(refresh + 1)
                        }
                    })

                    set_horarios_agendados(aux_schedueles)
                    // setRefresh(refresh + 1)

                })
                .catch(() => 404)
        }

    }

    const change_aulas_date = e => {

        horario.forEach((element) => {
            element.state = true
        })

        if(modal_instrutor_id !== '') {
            reqGET(`${api_crud_base}/estancia/aula/event/instrutor/${getTokenInfo().companycode}/${e.target.value}`)
                .then(res => { 

                    let aux_schedueles = []
                    res.data.forEach((v) => {
                        if(v.info.detail.start.includes(e.target.value) && v.info.instrutor.id === modal_instrutor_id) {
                            aux_schedueles.push({
                                start: v.info.detail.start,
                                end: v.info.detail.end,
                            })

                            let x = horario
                            if(v.info.category === modal_category) {
                                x.forEach((element) => {
                                    if(v.info.detail.start.includes(element.begin)) {
                                        element.state = false
                                    }
                                })
                            }
                            set_horario(x)
                        }
                    })

                    set_horarios_agendados(aux_schedueles)
                    setRefresh(refresh + 1)
                    console.log('aux_schedueles', aux_schedueles)

                })
                .catch(() => 404)
        }

        set_modal_date(e.target.value)
        console.log(e.target.value)
        console.log(modal_date)

    }

    const change_aulas_instrutor = e => {
        console.log(e)

        horario.forEach((element) => {
            element.state = true
        })

        if(modal_date !== '') {
            reqGET(`${api_crud_base}/estancia/aula/event/instrutor/${getTokenInfo().companycode}/${modal_date}`)
                .then(res => { 

                    let aux_schedueles = []
                    res.data.forEach((v) => {
                        if(v.info.detail.start.includes(modal_date) && v.info.instrutor.id === e.value) {
                            aux_schedueles.push({
                                start: v.info.detail.start,
                                end: v.info.detail.end,
                            })

                            let x = horario
                            if(v.info.category === modal_category) {
                                x.forEach((element) => {
                                    if(v.info.detail.start.includes(element.begin)) {
                                        element.state = false
                                    }
                                })
                            }
                            set_horario(x)
                            setRefresh(refresh + 1)
                        }
                    })

                    set_horarios_agendados(aux_schedueles)
                    setRefresh(refresh + 1)
                    console.log('aux_schedueles', aux_schedueles)

                })
                .catch(() => 404)
        }
        
        set_modal_instrutor_id(e.value)
        set_modal_instrutor_name(e.label)

    }

    const handleInsert = () => {
        let dados = JSON.parse(JSON.stringify(data_interface))
        dados.info.companycode = getTokenInfo().companycode
        dados.info.name = modal_name
        dados.info.category = modal_category
        dados.info.detail['calendarId'] = modal_category_id
        dados.info.instrutor.id = modal_instrutor_id
        dados.info.instrutor.name = modal_instrutor_name

        console.log('modal_horario', modal_horario)

        // if(modal_name === '') {
        //     Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_name, '', 'info')
        //     return
        // }
        if(modal_instrutor_id === '') {
            Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_instrutor, '', 'info')
            return
        }
        if(modal_category_id === '') {
            Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_category, '', 'info')
            return
        }
        if(modal_date === '') {
            Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_date, '', 'info')
            return
        }
        if(modal_horario.length === 0) {
            Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_horario, '', 'info')
            return
        }

        modal_horario.forEach(el => {
            dados.info.detail.start = modal_date + 'T' + el.begin
            dados.info.detail.end = modal_date + 'T' + el.end

            reqPOST(api_crud_route, dados)
                .then(() => { 
                    //props.history.push(endpoints.list) 

                    get_events(modal_date, modal_date)
                })
                .catch(() => Swal.fire(language[lang].insert_error, '', 'info'))

        })

        unCheck()
        setRefresh(refresh + 1)

    }

    const unCheck = () => {
        set_modal_instrutor_id('')
        set_modal_instrutor_name('')
        set_modal_category_id('')
        set_modal_category('')
        set_modal_horario([])
        set_horario(h)

        let elements = document.querySelectorAll(`[id^="horario_"]`);
        elements.forEach(el => {
            el.checked = false
            el.state = false
        })
        setRefresh(refresh + 1)
    }

    const handleEdit = () => {

        reqGET(`${api_crud_base}/estancia/aula/event/${getTokenInfo().companycode}/${modal_event_id}`)
            .then(res => { 

                let dados = res.data[0]
                // dados.id = modal_event_id
                // dados.info.companycode = getTokenInfo().companycode
                // dados.info.name = modal_name
                dados.info.category = modal_category
                // dados.info.detail['calendarId'] = '1' // modal_category_id
                dados.info.instrutor.id = modal_instrutor_id
                dados.info.instrutor.name = modal_instrutor_name

                if(modal_instrutor_id === '') {
                    Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_instrutor, '', 'info')
                    return
                }
                if(modal_date === '') {
                    Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_date, '', 'info')
                    return
                }
                if(modal_horario.length === 0) {
                    Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_horario, '', 'info')
                    return
                }

                modal_horario.forEach(el => {
                    dados.info.detail.start = modal_date + 'T' + el.begin
                    dados.info.detail.end = modal_date + 'T' + el.end

                    reqPUT(api_crud_route, dados)
                        .then(() => { 
                            //props.history.push(endpoints.list) 

                            get_events(modal_date, modal_date)
                        })
                        .catch(() => Swal.fire(language[lang].insert_error, '', 'info'))

                })

                setRefresh(refresh + 1)

            })

    }

    const handleCancel = async () => {

        let today = new Date();
        let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();
        let hour_aux = String(today.getHours()).padStart(2, '0') + ':' + String(today.getMinutes()).padStart(2, '0') + ':' + String(today.getSeconds()).padStart(2, '0');
        let timestamp_aux = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0') + 'T' + String(today.getHours()).padStart(2, '0') + ':' + String(today.getMinutes()).padStart(2, '0') + ':' + String(today.getSeconds()).padStart(2, '0');

        let justificacao = ''
        let justificacao_2 = ''

        const { value: formValues } = await Swal.fire({
            title: 'Cancelar esta marcação', 
            input: 'select',
            inputOptions: {
              'Cancelamento a pedido do cliente': 'Cancelamento a pedido do cliente',
              'Cancelamento devido a condições meteorológicas adversas ou falta de neve': 'Cancelamento devido a condições meteorológicas adversas ou falta de neve',
              'Cancelamento devido a acessos rodoviários encerrados': 'Cancelamento devido a acessos rodoviários encerrados'
            },
            inputPlaceholder: 'Escolha uma opção',
            showCancelButton: true,
            inputValidator: () => {
              return new Promise((resolve) => {
                  resolve()
              })
            }
        })

        if(formValues) {
            justificacao_2 = formValues
        }

        justificacao = language[lang].cancel_aula_opt_01_txt

        // Swal.fire({
		// 	title: language[lang].cancel_title,
		// 	text: language[lang].cancel_text,
		// 	icon: 'question',
		// 	showCancelButton: true,
		// 	confirmButtonColor: '#0095e8',
		// 	cancelButtonColor: '#d9214e',
		// 	confirmButtonText: language[lang].delete_confirm,
		// 	cancelButtonText: language[lang].delete_cancel
		// })
		// .then((result) => {
		// 	if (result.isConfirmed) {
                if (justificacao !== '' && justificacao_2 !== '') {

                    reqGET(`${api_crud_base}/estancia/aula/event/${getTokenInfo().companycode}/${modal_event_id}`)
                        .then(res => { 

                            let dados = res.data[0]
                            // dados.id = modal_event_id
                            // dados.info.companycode = getTokenInfo().companycode
                            // dados.info.name = modal_name
                            // dados.info.category = modal_category
                            // dados.info.detail['calendarId'] = modal_category_id
                            // dados.info.instrutor.id = modal_instrutor_id
                            // dados.info.instrutor.name = modal_instrutor_name

                            // if(modal_instrutor_id === '') {
                            //     Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_instrutor, '', 'info')
                            //     return
                            // }
                            // if(modal_date === '') {
                            //     Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_date, '', 'info')
                            //     return
                            // }
                            // if(modal_horario.length === 0) {
                            //     Swal.fire(language[lang].insert_error + ' ' + language[lang].insert_error_horario, '', 'info')
                            //     return
                            // }

                            modal_horario.forEach(async el => {

                                if(dados.info.detail['state'] === 'done' || dados.info.detail['state'] === 'cancel') {

                                    Swal.fire('', 'Não pode cancelar esta aula.', 'info')

                                }
                                else if(dados.info.detail['state'] !== 'busy') {

                                    dados.info.detail.start = modal_date + 'T' + el.begin
                                    dados.info.detail.end = modal_date + 'T' + el.end
                                    
                                    dados.info.detail.calendarId = "3"
                                    dados.info.detail.state = "cancel"

                                    if(dados.info['cancelamento'] !== undefined && dados.info['cancelamento'] !== null) {
                                    }
                                    else {
                                        dados.info['cancelamento'] = []
                                    }

                                    let aux_cancelamento = {
                                        motivo: justificacao_2,
                                        inscritos: []
                                    } 
                                    dados.info['cancelamento'].push(aux_cancelamento)
        
                                    await reqPUT(`${api_crud_base}/estancia/aula/event`, dados)
                                        .then(() => { 
                                            //props.history.push(endpoints.list) 
                                            setRefresh(refresh + 1)
                                        })
                                        .catch(() => console.log('erro a cancelar o marcação de aula'))
        
                                }
                                else {

                                    dados.info.detail.start = modal_date + 'T' + el.begin
                                    dados.info.detail.end = modal_date + 'T' + el.end
                                    
                                    // EM VEZ DE CANCELAR TORNAR A FICAR DISPONIVEL
                                    // dados.info.detail.calendarId = "3"
                                    // dados.info.detail.state = "cancel"
                                    dados.info.detail.calendarId = "1"
                                    dados.info.detail.state = "free"

                                    // NAO ENVIAR PARA INSTRUTOR
                                    if(0 && dados.info.instrutor.id !== undefined && dados.info.instrutor.id !== '') {
                                        // SEND MAIL TO INSTRUCTOR
                                        await reqGET(`${api_crud_base}/entities/${getTokenInfo().companycode}/${dados.info.instrutor.id}`)
                                            .then(res => { 

                                                if(res.data[0].info.email !== '') {

                                                    let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                                                        '<tr style="border-collapse: collapse;">' +
                                                            '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                                                '<div>' +
                                                                    '<span><b>' + language[lang].mail_scheduele_cancel_title + '</b></span>' +
                                                                '</div>' +
                                                            '</td>' + 
                                                            '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                                                '<div>'+
                                                                    '<span>'+ today_aux + '</span>'+
                                                                '</div>'+
                                                            '</td>' +
                                                        '</tr>' +
                        
                                                        '<tr>' +
                                                            '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
                                                        '</tr>' +
                                                        '<tr style="border-collapse: collapse;">' +
                                                            '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                                                '<div>'+
                                                                    '<br/>'+
                                                                    '<span>' + justificacao + '</span>'+
                                                                    '<br/>'+
                                                                '</div>'+
                                                            '</td>' +
                                                        '</tr>' +
                                                    '</table>'
                
                                                    let sendFrom = Hosts.contactFrom
                                                    let sendTo = [res.data[0].info.email]
                                                    let sendToCC = ['web.dev@assec.pt']
                                                    let subject = language[lang].aula_cancelada_sub
                                                    let content = mail_content
                                                    let attachment = []
                
                                                    functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
                                                    //functionSendMail('web.dev@assec.pt', [email], [], 'Cancelar marcação de aula', mail_content, [])
                                                        .then((res) => {
                                                            if(res === true) {
                                                                // document.getElementById('agree').checked = false
                                                                // Swal.fire({
                                                                //     title: language[lang].opinion_form,
                                                                //     text: language[lang].sent_successfully,
                                                                //     icon: 'success',
                                                                //     confirmButtonColor: '#08396a',
                                                                // })
                                                            }
                                                            else {
                                                                // Swal.fire({
                                                                //     title: language[lang].opinion_form,
                                                                //     text: language[lang].sent_successfully,
                                                                //     icon: 'success',
                                                                //     confirmButtonColor: '#08396a',
                                                                // })
                                                            }
                                                        })

                                                }

                                            })
                                            .catch()
                                    }

                                    if(dados.info.inscritos !== undefined && dados.info.inscritos[0].id !== undefined && dados.info.inscritos[0].id !== '') {

                                        if(dados.info.inscritos.length > 0 && dados.info.inscritos[0].id_encomenda !== undefined && dados.info.inscritos[0].id_encomenda !== '') {

                                            await reqGET(`${api_crud_base}/store/order/${getTokenInfo().companycode}/${dados.info.inscritos[0].id_encomenda}`)
                                                .then(async res => { 


                                                    console.log('res.data.length', res.data.length)

                                                    if(res.data.length === 1) {
                                                        
                                                        // encontrar QRs a ocultar
                                                        // console.log('dados.info.inscritos[0]', dados.info.inscritos[0])
                                                        // console.log('res.data[0].info.documento.linhas', res.data[0].info.documento.linhas)
                                                        // console.log('res.data[0].info.documento.linhas[dados.info.inscritos[0].id_aula_dentro_encomenda]', res.data[0].info.documento.linhas[dados.info.inscritos[0].id_aula_dentro_encomenda])
                                                        // console.log('res.data[0].info.qr', res.data[0].info.qr)

                                                        res.data[0].info.qr.forEach(el_qr_aux => {
                                                            dados.info.inscritos[0].aux_qrcode.forEach(el_qr_aux_2 => {
                                                                if(el_qr_aux.qr_code === el_qr_aux_2.qr_code) {
                                                                    el_qr_aux.show_qr = false
                                                                }
                                                            })
                                                        })

                                                        res.data[0].info.documento.linhas[dados.info.inscritos[0].id_aula_dentro_encomenda].aula_marcada = ""
                                                        res.data[0].info.documento.linhas[dados.info.inscritos[0].id_aula_dentro_encomenda].quantidade_aux_em_caso_de_aula = parseInt(res.data[0].info.documento.linhas[dados.info.inscritos[0].id_aula_dentro_encomenda].quantidade_aux_em_caso_de_aula) + parseInt(res.data[0].info.qr.length)

                                                        await reqPUT(`${api_crud_base}/store/order`, res.data[0])
                                                            .then(() => { 

                                                            })
                                                            .catch(() => Swal.fire(language[lang].insert_error, '', 'info'))

                                                        return res.data
                                                    }

                                                    
                                                })
                                                .catch(() => {})

                                            // console.log('order_aux', order_aux)

                                        }

                                        // console.log('dados', dados)
                                        // console.log('dados.info.instrutor.id', dados.info.instrutor.id)
                                        // console.log('schedueles', schedueles)

                                        let y = schedueles.filter(el_qr => el_qr.id !== dados.id && el_qr.instrutor.id === dados.info.instrutor.id && ( (el_qr.start === dados.info.detail.start) ))
                                        let y2 = schedueles.filter(el_qr => el_qr.id !== dados.id && el_qr.instrutor.id === dados.info.instrutor.id && ( (dados.info.detail.end > el_qr.start && dados.info.detail.end < el_qr.end) ))
                                        let y3 = schedueles.filter(el_qr => el_qr.id !== dados.id && el_qr.instrutor.id === dados.info.instrutor.id && ( (dados.info.detail.start > el_qr.start && dados.info.detail.start < el_qr.end) ))
                                        if(y.length > 0) {
                                            y.forEach((el_cancelar) => {
                                                reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/${Hosts.companycode}/${el_cancelar['id']}`)
                                                    .then(res_aula_2 => { 

                                                        let evento_c = res_aula_2.data[0]
                                                        evento_c.info.detail['state'] = 'free';
                                                        evento_c.info.detail['calendarId'] = '1';

                                                        reqPUT(`${Hosts.SIMCore_API}/estancia/aula/event`, evento_c)
                                                            .then(() => {

                                                            })

                                                    })
                                            })
                                        }
                                        if(y2.length > 0) {
                                            y2.forEach((el_cancelar) => {
                                                reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/${Hosts.companycode}/${el_cancelar['id']}`)
                                                    .then(res_aula_2 => { 

                                                        let evento_c = res_aula_2.data[0]
                                                        evento_c.info.detail['state'] = 'free';
                                                        evento_c.info.detail['calendarId'] = '1';

                                                        reqPUT(`${Hosts.SIMCore_API}/estancia/aula/event`, evento_c)
                                                            .then(() => {

                                                            })

                                                    })
                                            })
                                        }
                                        if(y3.length > 0) {
                                            y3.forEach((el_cancelar) => {
                                                reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/${Hosts.companycode}/${el_cancelar['id']}`)
                                                    .then(res_aula_2 => { 

                                                        let evento_c = res_aula_2.data[0]
                                                        evento_c.info.detail['state'] = 'free';
                                                        evento_c.info.detail['calendarId'] = '1';

                                                        reqPUT(`${Hosts.SIMCore_API}/estancia/aula/event`, evento_c)
                                                            .then(() => {

                                                            })

                                                    })
                                            })
                                        }


                                        if(Array.isArray(dados.info.inscritos)) {
                                            for await (let el_inscritos of dados.info.inscritos) {

                                                if(el_inscritos.id !== '') {

                                                    // SEND MAIL TO CLIENT
                                                    await reqGET(`${api_crud_base}/entities/${getTokenInfo().companycode}/${el_inscritos.id}`)
                                                        .then(res => { 

                                                            let n_aux = {
                                                                "id": "", 
                                                                "data": today_aux, 
                                                                "hora": hour_aux, 
                                                                "foi_vista": false, 
                                                                "timestamp": timestamp_aux + ".803Z", 
                                                                "body_notif": "Aula cancelada."
                                                            }

                                                            res.data[0].notifications.push(n_aux)

                                                            reqPOST(`${api_crud_base}/entities`, res.data[0])
                                                                .then(() => {})
                                                                .catch(() => {})


                                                            if(res.data[0].info.email !== '') {

                                                                let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                                                                    '<tr style="border-collapse: collapse;">' +
                                                                        '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                                                            '<div>' +
                                                                                '<span><b>' + language[lang].mail_scheduele_cancel_title + '</b></span>' +
                                                                            '</div>' +
                                                                        '</td>' + 
                                                                        '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                                                            '<div>'+
                                                                                '<span>'+ today_aux + '</span>'+
                                                                            '</div>'+
                                                                        '</td>' +
                                                                    '</tr>' +

                                                                    '<tr>' +
                                                                        '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
                                                                    '</tr>' +
                            
                                                                    '<tr style="border-collapse: collapse;">' +
                                                                        '<td colspan="2" align="left" style="padding: 0px 40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                                                            '<div>'+
                                                                                '<span><b>'+ language[lang].encomenda_marcacao +': </b><label>' + el_inscritos.id_encomenda + '</label></span>' +
                                                                                '<br/>'+
                                                                                '<span><b>'+ language[lang].data_marcacao +': </b><label>' + modal_date + '</label></span>' +
                                                                                '<br/>'+
                                                                                '<span><b>'+ language[lang].hora_marcacao + ': </b><label>' + el.begin + '</label></span>' +
                                                                                '<br/>'+
                                                                                '<span><b>'+ language[lang].modalidade_marcacao + ': </b><label>' + dados.info.category + '</label></span>' +
                                                                            '</div>'+
                                                                        '</td>' +
                                                                    '</tr>' +

                                                                    '<tr>' +
                                                                        '<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
                                                                    '</tr>' +

                                                                    '<tr style="border-collapse: collapse;">' +
                                                                        '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                                                                            '<div>'+
                                                                                '<br/>'+
                                                                                '<span>' + justificacao + '</span>'+
                                                                                '<br/>'+
                                                                            '</div>'+
                                                                        '</td>' +
                                                                    '</tr>' +
                                                                '</table>'
                            
                                                                let sendFrom = Hosts.contactFrom
                                                                let sendTo = [res.data[0].info.email]
                                                                let sendToCC = ['web.dev@assec.pt']
                                                                let subject = language[lang].aula_cancelada_sub
                                                                let content = mail_content
                                                                let attachment = []
                            
                                                                functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
                                                                //functionSendMail('web.dev@assec.pt', [email], [], 'Cancelar marcação de aula', mail_content, [])
                                                                    .then((res) => {
                                                                        if(res === true) {
                                                                            // document.getElementById('agree').checked = false
                                                                            // Swal.fire({
                                                                            //     title: language[lang].opinion_form,
                                                                            //     text: language[lang].sent_successfully,
                                                                            //     icon: 'success',
                                                                            //     confirmButtonColor: '#08396a',
                                                                            // })
                                                                        }
                                                                        else {
                                                                            // Swal.fire({
                                                                            //     title: language[lang].opinion_form,
                                                                            //     text: language[lang].sent_successfully,
                                                                            //     icon: 'success',
                                                                            //     confirmButtonColor: '#08396a',
                                                                            // })
                                                                        }
                                                                    })

                                                            }

                                                        })
                                                        .catch()

                                                }
                                            }

                                        }
                                    }

                                    if(dados.info['cancelamento'] !== undefined && dados.info['cancelamento'] !== null) {
                                    }
                                    else {
                                        dados.info['cancelamento'] = []
                                    }
                                    let aux_cancelamento = {
                                        motivo: justificacao_2,
                                        inscritos: JSON.parse(JSON.stringify(dados.info.inscritos))
                                    } 
                                    dados.info['cancelamento'].push(aux_cancelamento)

                                    dados.info.inscritos = [{
                                        id: '',
                                        name: ''
                                    }]

                                    await reqPUT(api_crud_route, dados)
                                        .then(() => { 
                                            //props.history.push(endpoints.list) 

                                            get_events(modal_date, modal_date)
                                            setRefresh(refresh + 1)
                                        })
                                        .catch(() => Swal.fire(language[lang].insert_error, '', 'info'))

                                }
                            })


                        })

                }
                else {
                    Swal.fire('', 'Tem de escolher uma opção.', 'info')
                }
        //     }
        // })

    }

    const handleDelete = async () => {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

                // APAGAR REGISTO
                    reqDELETE(api_crud_route, { id: modal_event_id })
                        .then(() => {

                            // let aux_schedueles = schedueles.filter(v => parseInt(v.id) !== parseInt(schedule.id))
                            // setSchedueles(aux_schedueles)


                            console.log('modal_date', modal_date)
                            get_events(modal_date, modal_date)
                            return

                            // let d1 = new Date(today.getFullYear(), today.getMonth(), 1)
                            // let d2 = new Date(today.getFullYear(), today.getMonth() + 1, 0)

                            // let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
                            // let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

                            // get_events(start, end)

                        })
                        .catch(error => console.log(error))

            }
        })

    }

    const handleSelectHorario = e => {
		const { dataset } = e.target;
		const { begin, end } = dataset;

        let aux = modal_horario.filter(el => el.begin === begin)
        if(aux.length === 0) {
            modal_horario.push({begin: begin, end: end})

            set_modal_horario(modal_horario)
        }
        else {
            let x = modal_horario.filter(el => el.begin !== begin)

            set_modal_horario(x)
        }

		// setRefresh(refresh + 1)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados.current.info))
	}

    const change_aulas_horario = e => {
        const { begin, end } = e;

        set_modal_horario_value_edit(begin + ' - ' + end)
        set_modal_horario_label_edit(begin + ' - ' + end)

        modal_horario[0] = {begin: begin, end: end}
        set_modal_horario(modal_horario)
    }

    const addDateScheduel = (e) => {
        //const { calendarId, title, start, end, isAllDay, isPrivate, location, state, raw } = e;
        //const companycode = getTokenInfo().companycode;

        console.log('add')
        return

    }

    const editDateScheduel = (e) => {
        //const { schedule, changes } = e;

        console.log('edit')
        return


        /*
        let aux_scheduel = schedueles.filter(v => v.id === schedule.id)
        let aux_schedueles = schedueles.filter(v => v.id !== schedule.id)

        aux_schedueles.push(aux_scheduel[0])
        aux_schedueles.forEach((v) => {
            if(v.id === schedule.id) {
                var obj = changes;
                for(var key in obj) {
                    var value = obj[key];
                    //console.log(key + ": " + value);
                    v[key] = value
                }

            }
        })

        //console.log(aux_schedueles)
        setSchedueles(aux_schedueles)
        */
    }

    const editAula = async (e) => {
        const { schedule } = e;

        // console.log('schedules', schedueles)
        // console.log('schedule', schedule)

        let d = schedule.start.getFullYear() + '-' + ((schedule.start.getMonth() + 1) + '').padStart(2, '0') + '-' + (schedule.start.getDate() + '').padStart(2, '0')

        let hs = schedule.start.getHours() < 10 ? '0' + schedule.start.getHours() : schedule.start.getHours()
        let ms = schedule.start.getMinutes() < 10 ? '0' + schedule.start.getMinutes() : schedule.start.getMinutes()

        let he = schedule.end.getHours() < 10 ? '0' + schedule.end.getHours() : schedule.end.getHours()
        let me = schedule.end.getMinutes() < 10 ? '0' + schedule.end.getMinutes() : schedule.end.getMinutes()

        // let inst = instrutores.filter(el => parseInt(el.value) === parseInt(modal_instrutor_id))
        // let inst = instrutores.filter(el => schedule.title.includes(el.label))
        
        let schedule_aux = schedueles.filter(el => el.id === schedule.id)
        console.log('schedule_aux', schedule_aux)

        let instrutor_aux = []
        let inscritos_aux = []
        if(schedule_aux.length === 1) {
            instrutor_aux.push(schedule_aux[0].instrutor)
            inscritos_aux = schedule_aux[0].inscritos

            set_modal_category(schedule_aux[0].tipo)
        }
        console.log('inscritos_aux', inscritos_aux)
        let event_data_aux = ''



        if(Array.isArray(inscritos_aux)) {
            for await (let el_inscritos of inscritos_aux) {

                if(el_inscritos.id !== undefined && el_inscritos.id !== null && el_inscritos.id !== '') {

                    let entity_aux = await reqGET(`${api_crud_base}/entities/${getTokenInfo().companycode}/${el_inscritos.id}`)
                        .then(res => { 
                            return res.data
                        })
                        .catch(() => {})

                    console.log('entity_aux', entity_aux)

                    event_data_aux += '<p>'
                    event_data_aux += '<strong>N.º da encomenda:</strong> ' +  el_inscritos.id_encomenda + '<br />'
                    event_data_aux += '<strong>Responsável:</strong> ' + entity_aux[0].info.name + '<br />'
                    event_data_aux += '<strong>E-mail:</strong> ' + entity_aux[0].info.email + '<br />'
                    event_data_aux += entity_aux[0].contacts[0].mobile_phone !== undefined ? '<strong>Contacto:</strong> ' + entity_aux[0].contacts[0].mobile_phone + '<br />' : ''
                    // event_data_aux += '<strong>Número de alunos:</strong> ' + el_inscritos.aux_qrcode.length + '<br />'
                    event_data_aux += '</p>'
                }
            }
        }
        set_modal_event_dados(event_data_aux)

        // Swal.fire({
		// 	title: language[lang].edit_aula_title,
		// 	text: language[lang].edit_aula_text,
		// 	icon: 'question',
		// 	showCancelButton: true,
		// 	showDenyButton: true,
		// 	confirmButtonColor: '#0095e8',
		// 	denyButtonColor: '#d9214e',
		// 	cancelButtonColor: '#6c757d',
		// 	confirmButtonText: language[lang].edit_aula_confirm,
		// 	cancelButtonText: language[lang].edit_aula_cancel,
        //     denyButtonText: language[lang].edit_aula_deny,
		// })
		// .then((result) => {

        //     if(result.isConfirmed) {

                set_modal_date(d)
                // console.log('instrutor_aux', instrutor_aux)
                if(instrutor_aux.length > 0) {
                    set_modal_instrutor_id(instrutor_aux[0].id)
                    set_modal_instrutor_name(instrutor_aux[0].name)
                }
                set_modal_event_id(schedule.id)
                // console.log('schedule.id', schedule.id)

                set_modal_horario_value_edit(hs + ':' + ms + ' - ' + he + ':' + me)
                set_modal_horario_label_edit(hs + ':' + ms + ' - ' + he + ':' + me)

                modal_horario[0] = {begin: hs + ':' + ms, end: he + ':' + me}
                set_modal_horario(modal_horario)

                // props.history.push({ pathname: endpoints.regist, state: { item: {id: schedule.id}, operation: 'edit' } });
                document.getElementById("btn_edit_modal").click();

            // }
            // else if(result.isDismissed) {

            // }
            // else if(result.isDenied) {

            //     // APAGAR REGISTO
            //     reqDELETE(api_crud_route, { id: schedule.id })
            //         .then(() => {

            //             // let aux_schedueles = schedueles.filter(v => parseInt(v.id) !== parseInt(schedule.id))
            //             // setSchedueles(aux_schedueles)

            //             let d1 = new Date(today.getFullYear(), today.getMonth(), 1)
            //             let d2 = new Date(today.getFullYear(), today.getMonth() + 1, 0)

            //             let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            //             let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            //             get_events(start, end)

            //         })
            //         .catch(error => console.log(error))

            // } 

		// })

        
    }

    const removeDateScheduel = (e) => {
        const { schedule } = e;

        let aux_schedueles = schedueles.filter(v => v.id !== schedule.id)
        setSchedueles(aux_schedueles)
    }

    const myTheme = {
        // Theme object to extends default dark theme.
    };
      
    const myTemplate = {
        // milestone(schedule) {
        //     return `<span style="color:#fff;background-color: ${schedule.bgColor};">${schedule.title}</span>`;
        // },
        // milestoneTitle() {
        //     return 'Milestone';
        // },
        // task: function(schedule) {
        //     return '#' + schedule.title;
        // },
        // taskTitle: function() {
        //     return '<span className="tui-full-calendar-left-content">Tarefa</span>';
        // },
        // allday(schedule) {
        //     return `${schedule.title}<i className="fa fa-refresh"></i>`;
        // },
        // alldayTitle() {
        //     return language[lang].calendar_allday;
        // },
        // popupIsAllDay: function() {
        //     return language[lang].calendar_allday;
        // },
        popupStateFree: function() {
            return language[lang].calendar_free;
        },
        popupStateBusy: function() {
            return language[lang].calendar_busy;
        },
        titlePlaceholder: function() {
            return language[lang].calendar_title_placeholder;
        },
        locationPlaceholder: function() {
            return language[lang].calendar_location_placeholder;
        },
        startDatePlaceholder: function() {
            return language[lang].calendar_start_placeholder;
        },
        endDatePlaceholder: function() {
            return language[lang].calendar_end_placeholder;
        },
        popupSave: function() {
            return language[lang].calendar_save;
        },
        popupUpdate: function() {
            return language[lang].calendar_update;
        },
        // popupDetailDate: function(isAllDay, start, end) {
        //     var isSameDate = moment(start).isSame(end);
        //     var endFormat = (isSameDate ? '' : 'YYYY.MM.DD ') + 'hh:mm a';

        //     if (isAllDay) {
        //         return moment(start).format('YYYY.MM.DD') + (isSameDate ? '' : ' - ' + moment(end).format('YYYY.MM.DD'));
        //     }

        //     return (moment(start).format('YYYY.MM.DD hh:mm a') + ' - ' + moment(end).format(endFormat));
        // },
        popupEdit: function() {
            return language[lang].calendar_edit;
        },
        popupDelete: function() {
            return language[lang].calendar_delete;
        }
    }

    const calendarRef = React.createRef();
    const handleClickButton = (type) => {
        const calendarInstance = calendarRef.current.getInstance();

        console.log('type', type)
        // Swal.fire('', 'type: ' + type, 'info')

        if(type === 'today') {
            calendarInstance.today();

            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)


            console.log('d1', d1)
            console.log('d2', d2)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
            set_map_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
            set_modal_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
        }
        if(type === 'prev') {
            calendarInstance.prev();

            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
            set_map_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
            set_modal_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
        }
        if(type === 'next') {
            calendarInstance.next();

            let d1 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth(), 1)
            let d2 = new Date(calendarInstance.getDate().getFullYear(), calendarInstance.getDate().getMonth() + 1, 0)

            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            get_events(start, end)
            set_map_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
            set_modal_date(calendarInstance.getDate().getFullYear() + '-' + ((calendarInstance.getDate().getMonth() + 1) + '').padStart(2, '0') + '-' + (calendarInstance.getDate().getDate() + '').padStart(2, '0'))
        }

        if(type === 'day') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }
        if(type === 'week') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }
        if(type === 'month') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }

        if(calendarInstance.getViewName() === 'day') {
            setcalendarTitle(calendarInstance.getDate()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
        }
        if(calendarInstance.getViewName() === 'week') {
            setcalendarTitle(calendarInstance.getDateRangeStart()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) + ' ~ ' + calendarInstance.getDateRangeEnd()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })) 
        }
        if(calendarInstance.getViewName() === 'month') {
            setcalendarTitle(calendarInstance.getDate()._date.toLocaleString(language[lang].calendar_language, { month: 'long', year: 'numeric' }))
        }

        //calendarInstance.toggleSchedules('0', true, true)

        //console.log(calendarInstance.getViewName())
        // console.log(calendarInstance.getDate())
        // console.log(calendarInstance.getDate()._date)
        // console.log(calendarInstance.getDate()._date.toLocaleString('default', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
    };
    const handleToggleButton = (e) => {
        const { value, dataset } = e.target
        const { status } = dataset

        let toHide = true
        let toHideChild = true
        let render = true

        const calendarInstance = calendarRef.current.getInstance();
        if(value === "all") {
            if(status === 'true') {
                // document.getElementById('calendar-' + value).removeAttribute('checked')
                document.getElementById('calendar-' + value).checked = false
                e.target.dataset.status = false
                toHide = true
            }
            else {
                //document.getElementById('calendar-' + value).setAttribute('checked', 'checked')
                document.getElementById('calendar-' + value).checked = true
                e.target.dataset.status = true
                toHide = false
            }

            if(status !== 'true')
                toHideChild = false
            
            calendars.forEach((v) => {
                if(toHide) {
                    document.getElementById('calendar-' + v.id).dataset.status = false
                    // document.getElementById('calendar-' + v.id).removeAttribute('checked')
                    document.getElementById('calendar-' + v.id).checked = false
                    v.status = false
                }
                else {
                    document.getElementById('calendar-' + v.id).dataset.status = true
                    // document.getElementById('calendar-' + v.id).setAttribute('checked', 'checked')
                    document.getElementById('calendar-' + v.id).checked = true
                    v.status = true
                }
    
                calendarInstance.toggleSchedules(v.id, toHideChild, render)
            })
        }
        else {
            if(status === 'true') {
                document.getElementById('calendar-' + value).dataset.status = false
                // document.getElementById('calendar-' + value).removeAttribute('checked')
                document.getElementById('calendar-' + value).checked = false
                toHide = true
            }
            else {
                document.getElementById('calendar-' + value).dataset.status = true
                // document.getElementById('calendar-' + value).setAttribute('checked', 'checked')
                document.getElementById('calendar-' + value).checked = true
                toHide = false
            }

            let allChecked = true
            calendars.forEach((v) => {
                if(document.getElementById('calendar-' + v.id).dataset.status === 'false')
                    allChecked = false
            })

            if(allChecked) {
                document.getElementById('calendar-all').dataset.status = true
                document.getElementById('calendar-all').checked = true
            }
            else {
                document.getElementById('calendar-all').dataset.status = false
                document.getElementById('calendar-all').checked = false

            }

            calendarInstance.toggleSchedules(value, toHide, render)
        }
    }

    const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
            padding: "0px 5px",
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "0px 5px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
            padding: "0px 5px",
		}),
        indicatorContainer: base => ({
			...base,
            padding: "0px 5px",
        }),
	}

    const cancel_day = async () => {
        // console.log('date', map_date)

        Swal.fire({
            title: 'Cancelar as marcações do dia',
            text: "Tem a certeza que pretende continuar?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        })
        .then((result) => {
            if(result.isConfirmed) {

                schedueles.forEach(async el => {
                    if(el.start.includes(map_date)) {

                        await reqGET(`${api_crud_base}/estancia/aula/event/${getTokenInfo().companycode}/${el.id}`)
                            .then(res => { 

                                let dados = res.data[0]
                                if(dados.info.detail['state'] !== 'busy') {

                                    dados.info.detail['state'] = 'cancel'
                                    reqPUT(`${api_crud_base}/estancia/aula/event`, dados)
                                        .then(() => { 
                                            //props.history.push(endpoints.list) 
                                            setRefresh(refresh + 1)
                                        })
                                        .catch(() => console.log('erro a cancelar o dia'))

                                }
                                else {
                                }
        
                            })

                    }
                })

                get_events(modal_date, modal_date)

            }

        })

    }

    function toPDF() {
        var linhas = [] 
        var i = 0;

        let aux = schedueles.filter(el => el.start.includes(map_date))
        console.log('toPDF', schedueles)
        console.log('data', map_date)
        console.log('toPDF', aux)

        aux.forEach(el_a => {

            let x = linhas.filter(el => el.id === el_a.instrutor.id)
            if(x.length === 0) {
                let aux_el = { id: el_a.instrutor.id, name: el_a.instrutor.name }

                horario.forEach((_, k_hs) => {
                    aux_el['h' + k_hs] = ''

                    if(k_hs === horario.length - 1) {
                        aux_el['h' + horario.length] = ''
                        aux_el['h' + (horario.length + 1)] = ''
                        aux_el['h' + (horario.length + 2)] = ''
                    }
                })

                horario.forEach((el_hs, k_hs) => {
                    if(el_a.start.includes(el_hs.begin) && el_a.state === 'done') {
                        aux_el['h' + k_hs] = '['
                        aux_el['h' + (k_hs + 1)] = ']'
                    }
                })

                console.log('aux_el', aux_el)
                linhas.push(aux_el)
            }
            else {
                linhas.forEach(el => {
                    if(el.id === el_a.instrutor.id) {

                        horario.forEach((el_hs, k_hs) => {
                            if(el_a.start.includes(el_hs.begin) && el_a.state === 'done') {
                                el['h' + k_hs] = '['
                                el['h' + (k_hs + 1)] = ']'
                            }
                        })

                    }
                })
                
            }
        })

        console.log('linhas', linhas)
        //return
        const doc = new jsPDF('l','pt','a4');

        doc.autoTable({
            theme: 'striped', // 'striped'|'grid'|'plain'|'css'
            styles: {
                fontSize: 11,
                //textColor: [131, 161, 178],
                overflow: 'linebreak',
                valign: 'middle',
                // lineWidth: 0.02,
                // lineColor: [217, 216, 216],
            },
            columnStyles: { 
                h0: { halign: 'center' }, 
                h1: { halign: 'center' }, 
                h2: { halign: 'center' }, 
                h3: { halign: 'center' }, 
                h4: { halign: 'center' }, 
                h5: { halign: 'center' }, 
                h6: { halign: 'center' }, 
                h7: { halign: 'center' }, 
                h8: { halign: 'center' }, 
                h9: { halign: 'center' }, 
                h10: { halign: 'center' }, 
                h11: { halign: 'center' }, 
                h12: { halign: 'center' }, 
                h13: { halign: 'center' }, 
                h14: { halign: 'center' }, 
                h15: { halign: 'center' }
            },
            //headStyles: { backgroundColor: 'red' },
            headStyles: {
                fontSize: 11,
                fillColor: "#FFFFFF",
                textColor: '#000000',
                //lineWidth: 0.1,
                //lineColor: '#c4c4c4',
            },
            footStyles: {
                fontSize: 11,
                fillColor: "#FFFFFF",
                textColor: '#000000',
                //lineWidth: {top: 0, right: 0, bottom: 0.1, left: 0},
                //lineColor: "#c4c4c4",
                halign: 'right'
            },
            // head: [
            //    ['', '', '', '', '', '']
            // ],
            didParseCell: function (data) {
                if(data.cell.text.indexOf('[') > -1) {
                    data.cell.styles.fillColor = [131, 161, 178];
                    data.cell.styles.halign = 'left';
                    data.cell.styles.textColor = [131, 161, 178];
                    
                    data.cell.styles.lineColor = [255, 255, 255];
                    data.cell.styles.lineWidth = 0.02;
                }
                if(data.cell.text.indexOf('-') > -1) {
                    data.cell.styles.fillColor = [131, 161, 178];
                    data.cell.styles.halign = 'right';
                    data.cell.styles.textColor = [131, 161, 178];

                    data.cell.styles.lineColor = [255, 255, 255];
                    data.cell.styles.lineWidth = 0.02;
                }
                if(data.cell.text.indexOf(']') > -1) {
                    data.cell.styles.fillColor = [131, 161, 178];
                    data.cell.styles.halign = 'right';
                    data.cell.styles.textColor = [131, 161, 178];

                    data.cell.styles.lineColor = [255, 255, 255];
                    data.cell.styles.lineWidth = 0.02;
                }
            },
            margin: { top: 70 },
            body: linhas,
            foot: [
                [
                    { 
                    content: linhas.length + (linhas.length === 1 ? ' registo' : ' registos'), 
                    // styles: { 
                        // lineWidth: {
                        //     top: 0.1, 
                        //     right: 0, 
                        //     bottom: 0, 
                        //     left: 0
                        // }, 
                        // lineColor: "#000000"
                    // } 
                    },
                ],
                // [
                //     { content: '', colSpan: 15, styles: { lineWidth: {top: 0.1, right: 0, bottom: 0, left: 0}, lineColor: "#000000"} },
                // ]
            ],
            showFoot: 'lastPage',
            columns: [
                { header: 'Instrutor', dataKey: 'name' },
                { header: '09:30', dataKey: 'h0' },
                { header: '10:00', dataKey: 'h1' },
                { header: '10:30', dataKey: 'h2' },
                { header: '11:00', dataKey: 'h3' },
                { header: '11:30', dataKey: 'h4' },
                { header: '12:00', dataKey: 'h5' },
                { header: '12:30', dataKey: 'h6' },
                { header: '13:00', dataKey: 'h7' },
                { header: '13:30', dataKey: 'h8' },
                { header: '14:00', dataKey: 'h9' },
                { header: '14:30', dataKey: 'h10' },
                { header: '15:00', dataKey: 'h11' },
                { header: '15:30', dataKey: 'h12' },
                { header: '16:00', dataKey: 'h13' },
                { header: '16:30', dataKey: 'h14' },
                { header: 'Assinatura', dataKey: 'h15' },
            ],
        })

        // Optional - set properties on the document
        doc.setProperties({
            title: 'Mapa de Aulas',
            subject: 'Estância de Ski - Turistrela',
            author: 'Assec Sim!',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'Assec Sim!'
        });

        var pageCount = doc.internal.getNumberOfPages();
        for(i = 1; i <= pageCount; i++) {
            doc.setPage(i);

            // Top Page
            doc.setFont('helvetica', 'normal')
            doc.setFontSize(16)
            doc.text('ESTÂNCIA DE SKI - TURISTRELA', 41, 30, { align: 'left' })
            // doc.text('MAPA DE AULAS', doc.internal.pageSize.width / 2, 30, { align: 'center' })
            // Second Line
                doc.setFont('helvetica', 'normal')
                doc.setFontSize(12)
                doc.text('Mapa Diário de Aulas', doc.internal.pageSize.width / 2, 45, { align: 'center' })
            // Third Line
                doc.setFontSize(8)
                doc.text('Data: ' + map_date, 41, 60, { align: 'left' })
                doc.text('Funcionário(a): ', doc.internal.pageSize.width - 160, 60, { align: 'right' })

            // Bottom Page
            doc.setFont('helvetica', 'normal')
            doc.setFontSize(8)
            doc.text('ESTÂNCIA DE SKI - TURISTRELA - Sim!Estância (c) 2022 | Lic. 0001 ', 41, doc.internal.pageSize.height - 30, { align: 'left' })
            doc.text('Página ' + String(i) + ' de ' + String(pageCount), doc.internal.pageSize.width - 41, doc.internal.pageSize.height - 30, { align: 'right' })


            // Border Table Header
            doc.setDrawColor(0, 0, 0);
            doc.line(41, 70, doc.internal.pageSize.width - 41, 70); // horizontal line
            doc.line(41, 90, doc.internal.pageSize.width - 41, 90); // horizontal line
            doc.line(41, 70, 41, 90); // vertical line
            doc.line(doc.internal.pageSize.width - 41, 70, doc.internal.pageSize.width - 41, 90); // vertical line
        }

        // doc.autoTable({ html: '#my-table' })
        //doc.save('table.pdf')
        doc.save('mapa_aulas_' + map_date.replaceAll('-', '.') + '.pdf')
    }


    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards dash-cards-calendar header`}>
                <h2 className="dash-title">{language[lang].component_list}</h2>
                <p>{language[lang].component} / {language[lang].component_list}</p>
            </div>
        
            <div className={`dash-cards dash-cards-calendar body`}>
                <div className="container">
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body d-none">
                            <h2 className="dash-title">
                                {language[lang].scale}
                            </h2>
                        </div>

                        <div className="card-body">

                            <div className="pb-10">

                                <div id="aula" className="calendar estancia">
                                    <div className="calendar-header text-end">

                                        <div className="col-12 mt-5 mb-3 px-5">
                                            <button type="button" className={"btn btn-sm btn-primary download pdf rounded-0 me-3" + (selectedView === 'day' ? '' : ' d-none')} onClick={() => cancel_day()}>Cancelar dia</button>
                                            
                                            <button type="button" className={"btn btn-sm btn-primary download pdf rounded-0 me-3" + (selectedView === 'day' ? '' : ' d-none')} onClick={() => toPDF()}>Decarregar mapa de aulas</button>

                                            <span 
                                                className="btn btn-sm btn-secondary rounded-0 multi-item me-1"
                                                data-bs-toggle="modal" 
                                                data-bs-target={"#insert_modal"}
                                                onClick={() => unCheck()}
                                                title={language[lang].add_new_2}
                                            >
                                                <span>{language[lang].add_new_2}</span>
                                            </span>
                                            <span className="d-none" id="btn_edit_modal" data-bs-toggle="modal" data-bs-target={"#edit_modal"} />

                                            <Link className="btn btn-sm btn-secondary rounded-0 multi-item d-none" to={{ pathname: endpoints.regist }}  >
                                                <span>{language[lang].add_new}</span>
                                            </Link>
                                        </div>

                                        <div className="col-12 d-flex flex-stack my-5 px-5">
                                            <div className="flex-1 text-start">
                                                <button type="button" className="btn btn-sm btn-light move-day" onClick={() => handleClickButton('prev')} data-action="move-prev">
                                                    <i className="bi bi-chevron-left" data-action="move-prev"></i>
                                                </button>
                                                <button type="button" className="btn btn-sm btn-light move-day" onClick={() => handleClickButton('next')} data-action="move-next">
                                                    <i className="bi bi-chevron-right" data-action="move-next"></i>
                                                </button>

                                                <button type="button" className="btn btn-sm btn-light move-today ms-3" onClick={() => handleClickButton('today')} data-action="move-today">{language[lang].calendar_today}</button>
                                            </div>

                                            <div className="flex-1 text-center">
                                                <h4 className="m-0">{calendarTitle}</h4>
                                            </div>

                                            <div className="flex-1 text-end">
                                                {
                                                calendar_views.map((v, k) => {
                                                    return (
                                                        <button key={k} type="button" aria-pressed={selectedView === v.value ? "true" : "false"} className={selectedView === v.value ? "btn btn-sm btn-secondary" : "btn btn-sm btn-light"} onClick={() => handleClickButton(v.value)}>{v.name}</button>
                                                    )
                                                })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="calendar-body">
                                        <div className="col-12 px-5">
                                            <div className="row">
                                                <div className="col-2 d-none">
                                                    <div className="calendars"> 
                                                        <div className="btn-calendars">
                                                            <div className="form-check form-check-custom form-check-solid  my-2">
                                                                <input className="form-check-input" type="checkbox" id="calendar-all" defaultChecked="checked" data-status="true" value="all" onClick={handleToggleButton} />
                                                                <label className="form-check-label" htmlFor="calendar-all">
                                                                    <strong>{language[lang].calendar_viewall}</strong>
                                                                </label>
                                                            </div>
                                                            {
                                                            calendars.map((v, k) => {
                                                                return (
                                                                    <div key={k} className="form-check form-check-custom form-check-solid my-2">
                                                                        <input type="radio" className="form-check-input rounded-circle" data-s={v.status} style={{backgroundColor: v.bgColor, borderColor: v.borderColor}} id={'calendar-' + v.id} defaultChecked="checked" data-status="true" value={v.id} onClick={handleToggleButton} />
                                                                        <label className="form-check-label" htmlFor={'calendar-' + v.id}>
                                                                            {v.name}
                                                                        </label>
                                                                    </div>
                                                                )
                                                            })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <Calendar
                                                        ref={calendarRef}
                                                        height="auto"
                                                        calendars={calendars}
                                                        disableDblClick={true}
                                                        disableClick={false}
                                                        isReadOnly={false}
                                                        month={{
                                                            startDayOfWeek: 0,
                                                            daynames: language[lang].calendar_daynames
                                                        }}
                                                        schedules={schedueles}
                                                        scheduleView
                                                        taskView={false}
                                                        allDayView={false}
                                                        state="free"
                                                        template={myTemplate}
                                                        theme={myTheme}
                                                        timezones={[
                                                            {
                                                                timezoneName: 'Europe/Lisbon',
                                                                displayLabel: 'GMT+00:00',
                                                                tooltip: 'Lisbon'
                                                            }
                                                        ]}
                                                        useDetailPopup
                                                        useCreationPopup
                                                        view={selectedView}
                                                        week={{
                                                            hourStart: 8,
                                                            hourEnd: 19,
                                                            showTimezoneCollapseButton: true,
                                                            timezonesCollapsed: true,
                                                            daynames: language[lang].calendar_daynames
                                                        }}
                                                        onAfterRenderSchedule={() => { }}
                                                        onBeforeDeleteSchedule={(e) => {removeDateScheduel(e) }}
                                                        onClickDayname={() => { console.log('onClickDayname') }}
                                                        onClickSchedule={(e) => { editAula(e) }}
                                                        onClickTimezonesCollapseBtn={() => { console.log('onClickTimezonesCollapseBtn') }}
                                                        onBeforeUpdateSchedule={(e) => { editDateScheduel(e) }}
                                                        onBeforeCreateSchedule={(e) => { addDateScheduel(e) }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="modal bg-light fade" tabIndex="-1" id={"insert_modal"}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{language[lang].add_new}</h5>

                                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                        <i className="bi bi-x fs-2"></i>
                                    </div>
                                </div>

                                <div className="modal-body">
                                    <div className="row mb-3 d-none">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].field_name}</label>
                                            <input type="text" className="form-control mb-3" name="name" value={modal_name} onChange={(e) => set_modal_name(e.target.value)} placeholder={"Nome"} /> 
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6 mb-3">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].table_date}</label>

                                            <input type="date" className="form-control rounded-0" name="date" value={modal_date} onChange={(e) => change_aulas_date(e)} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6 mb-3">
                                            <label className="fs-5 fw-bold mb-2">{language[lang].instrutor}</label>
                                            
                                            <Select
                                                className="div-select"
                                                options={instrutores}
                                                name="client_type"
                                                value={modal_instrutor_id === '' ? null : { label: modal_instrutor_name, value: modal_instrutor_id }}
                                                placeholder={language[lang].instrutor_placeholder}
                                                onChange={change_aulas_instrutor}
                                                styles={custom_select_styles}
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="fs-5 fw-bold mb-2">{language[lang].type}</label>
                                            
                                            <Select
                                                className="div-select"
                                                options={aulas_types}
                                                name="client_type"
                                                value={modal_category === '' ? null : { label: modal_category, value: modal_category }}
                                                placeholder={language[lang].type_placeholder}
                                                onChange={change_aulas_type}
                                                styles={custom_select_styles}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3 ms-1 mt-2">
                                        {
                                        horario.map((element, key) => {
                                            return (
                                                <div key={key} className="col-6 col-sm-4 mb-3 form-check">
                                                    <label className={"form-check-label text-nowrap" + (element.state ? '' : ' disabled')} htmlFor={"horario_" + key}>
                                                        {element.begin} - {element.end}
                                                    </label>
                                                    <input 
                                                        id={"horario_" + key}
                                                        name={"horario_" + key}
                                                        value={element.begin}
                                                        data-begin={element.begin}
                                                        data-end={element.end}
                                                        type="checkbox" 
                                                        className={'form-check-input rounded-0'}
                                                        onChange={handleSelectHorario}
                                                        disabled={!element.state}
                                                        // defaultChecked={handleForfaitCheckVerify(element.id)}
                                                    />
                                                </div>
                                            )
                                        })
                                        }
                                    </div>

                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-light d-none" data-bs-dismiss="modal" onClick={unCheck}>{language[lang].close}</button>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleInsert}>{language[lang].save}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal bg-light fade" tabIndex="-1" id={"edit_modal"}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{language[lang].component_edit}</h5>

                                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                        <i className="bi bi-x fs-2"></i>
                                    </div>
                                </div>

                                <div className="modal-body">
                                    <div className="row mb-3 d-none">
                                        <div className="col-12">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].field_name}</label>
                                            <input type="text" className="form-control mb-3" name="name" value={modal_name} onChange={(e) => set_modal_name(e.target.value)} placeholder={"Nome"} /> 
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6 mb-3">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].table_date}</label>

                                            <input type="date" className="form-control rounded-0" name="date" style={{height: '38px'}} value={modal_date} /*onChange={(e) => change_aulas_date(e)}*/ disabled={true} />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="col-form-label fs-6 fw-bold">{language[lang].horario}</label>
                                            
                                            {
                                            0 ? 
                                                <Select
                                                    className="div-select d-none"
                                                    options={horario}
                                                    name="client_horario"
                                                    value={modal_horario_value_edit === '' ? null : { label: modal_horario_label_edit, value: modal_horario_value_edit }}
                                                    placeholder={language[lang].type_placeholder}
                                                    onChange={change_aulas_horario}
                                                    styles={custom_select_styles}
                                                />
                                            :
                                                null
                                            }
                                            <input type="text" className="form-control rounded-0" name="client_horario" style={{height: '38px'}} value={modal_horario_label_edit} /*onChange={(e) => change_aulas_date(e)}*/ disabled={true} />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6 mb-3">
                                            <label className="fs-6 fw-bold mb-2">{language[lang].instrutor}</label>
                                            
                                            <Select
                                                className="div-select"
                                                options={instrutores}
                                                name="client_type"
                                                value={modal_instrutor_id === '' ? null : { label: modal_instrutor_name, value: modal_instrutor_id }}
                                                placeholder={language[lang].instrutor_placeholder}
                                                onChange={change_aulas_instrutor}
                                                styles={custom_select_styles}
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="fs-6 fw-bold mb-2">{language[lang].type}</label>
                                            
                                            <Select
                                                className="div-select"
                                                options={aulas_types}
                                                name="client_type"
                                                value={modal_category === '' ? null : { label: modal_category, value: modal_category }}
                                                placeholder={language[lang].type_placeholder}
                                                onChange={change_aulas_type}
                                                styles={custom_select_styles}
                                            />
                                        </div>
                                    </div>

                                    <div className={"row mb-3" + (modal_event_dados === '' ? ' d-none' : '')}>
                                        <div className="col-md-12 mb-3">
                                            <label className="col-form-label fw-bold fs-6">{language[lang].table_dados}</label>

                                            <span id="event_data">
                                                {parse(modal_event_dados)}
                                            </span>
                                        </div>
                                    </div>

                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
                                    <button type="button" className={"btn btn-danger" + (modal_event_dados === '' ? '' : ' d-none')} data-bs-dismiss="modal" onClick={() => handleDelete()}>{language[lang].calendar_delete}</button>
                                    <button type="button" className={"btn btn-secondary" + (modal_event_dados === '' ? ' d-none' : '')} data-bs-dismiss="modal" onClick={() => handleCancel()}>{language[lang].calendar_cancel}</button>
                                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => handleEdit()}>{language[lang].save}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}